import { render, staticRenderFns } from "./ListMailboxes.vue?vue&type=template&id=fc011c40&scoped=true&"
import script from "./ListMailboxes.vue?vue&type=script&lang=js&"
export * from "./ListMailboxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc011c40",
  null
  
)

export default component.exports